import _toArray from "@babel/runtime/helpers/esm/toArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { List } from 'immutable';
import { shallowEqual } from 'recompose';
var ELLIPSIS = " \u2026";
var STYLE = {
  dominantBaseline: 'central',
  pointerEvents: 'none',
  userSelect: 'none',
  textAnchor: 'middle'
};
export var SvgText = /*#__PURE__*/function (_Component) {
  _inherits(SvgText, _Component);

  var _super = _createSuper(SvgText);

  function SvgText(props) {
    var _this;

    _classCallCheck(this, SvgText);

    _this = _super.call(this, props);
    _this.state = {
      lineOffset: 0,
      lines: []
    };
    return _this;
  } // Need to call getLines on componentDidMount because we cannot measure the
  // given text with getBBoxForWord (below) until this component is fully
  // rendered.


  _createClass(SvgText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getLines(this.props.children);
    } // When we get new props we are going to re-compute the lines for the text
    // because we may have new text or the position may have changed. Note that
    // since this operation performs several DOM manipulations we use the
    // shouldComponentUpdate method to prevent unnecessary checks.

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldComponentUpdate(nextProps, this.state)) {
        this.getLines(nextProps.children);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, _ref2) {
      var x = _ref.x,
          y = _ref.y,
          width = _ref.width,
          height = _ref.height,
          children = _ref.children;
      var linesOffset = _ref2.linesOffset,
          lines = _ref2.lines;
      return this.state.linesOffset !== linesOffset || !shallowEqual(this.state.lines, lines) || this.props.x !== x || this.props.y !== y || this.props.width !== width || this.props.height !== height || !shallowEqual(this.props.children, children);
    } // Helper method that uses the 'sampleEl' reference element to measure the
    // size of a given word. We insert the word into the DOM and measure the
    // sample element and then remove it from the DOM.

  }, {
    key: "getBBoxForWord",
    value: function getBBoxForWord(word) {
      var sampleEl = this.sampleEl;
      sampleEl.appendChild(document.createTextNode(word));
      var result = sampleEl.parentNode.getBBox();
      sampleEl.removeChild(sampleEl.childNodes[0]);
      return result;
    }
  }, {
    key: "getLines",
    value: function getLines() {
      var _this2 = this;

      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var width = this.props.width - this.props.padding * 2;
      var lineHeight = this.getBBoxForWord('K').height;

      var _text$split = text.split(/\s+/),
          _text$split2 = _toArray(_text$split),
          first = _text$split2[0],
          rest = _text$split2.slice(1);

      var allLines = rest.reduce(function (memo, word) {
        var next = "".concat(memo.last(), " ").concat(word);
        return _this2.getBBoxForWord(next).width < width ? memo.set(memo.size - 1, next) : memo.push(word);
      }, List([first])); // We make sure to always render at least one line, with the scaling around
      // these tspans there can be some finicky lineHeight values returned above.

      var maxLines = Math.floor(this.props.height / lineHeight) || 1;
      var lines = allLines.size <= maxLines ? allLines : allLines.take(maxLines).update(maxLines - 1, function (line) {
        return "".concat(line).concat(ELLIPSIS);
      });
      var divisor = Math.min(maxLines, lines.size) + 1;
      var lineOffset = this.props.height / divisor;
      this.setState({
        lines: lines,
        lineOffset: lineOffset
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("g", {
        className: this.props.className
      }, /*#__PURE__*/React.createElement("text", {
        style: {
          opacity: 0
        }
      }, /*#__PURE__*/React.createElement("tspan", {
        ref: function ref(el) {
          _this3.sampleEl = el;
        }
      })), /*#__PURE__*/React.createElement("text", null, this.state.lines.map(function (line, i) {
        return /*#__PURE__*/React.createElement("tspan", {
          style: STYLE,
          key: line,
          x: _this3.props.x + _this3.props.width / 2,
          y: _this3.props.y + _this3.state.lineOffset * (i + 1)
        }, line);
      })));
    }
  }]);

  return SvgText;
}(Component);